import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getProfileById } from "../../actions/profile";
import {
  getUsers,
  unfollowUser,
  addFollowingFriend,
  removeCasualFriend,
} from "../../actions/friend";
import {
  getSubscribers,
  getSubscriptions,
  getActiveSubscriptions,
} from "../../actions/subscribe";
import { removeCasualFriendNotifications } from "../../actions/notification";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import UserFriendItem from "../layout/IME/UserFriendItem";
import UserSubscriptionItem from "../layout/IME/UserSubscriptionItem";
import ActiveSubscriberItem from "../layout/Mentors/ActiveSubscriberItem";
import UserFollowerItem from "../layout/IME/UserFollowerItem";
import UserFollowingItem from "../layout/IME/UserFollowingItem";
import ApprovedMentorItem from "../layout/Employers/ApprovedMentorItem";
import ApprovalItem from "../layout/Mentors/ApprovalItem";
import UnfollowUser from "../layout/IME/UnfollowUser";
import UnfollowUserConfirm from "../layout/IME/UnfollowUserConfirm";
import Befriend from "../layout/IME/Befriend";

import GreenSpinner from "../../img/Green_Spinner.gif";
import RedSpinner from "../../img/Red_Spinner.gif";
import BlueSpinner from "../../img/Blue_Spinner.gif";
import BefriendConfirm from "../layout/IME/BefriendConfirm";
import RemoveFriend from "../layout/IME/RemoveFriend";

const Users = ({
  match,
  auth: { user, isAuthenticated },
  profile: { profile },
  friend: { friends, loading },
  getProfileById,
  getUsers,
  unfollowUser,
  addFollowingFriend,
  removeCasualFriend,
  removeCasualFriendNotifications,
  subscribe: {
    subscribers,
    subscriptions,
    activesubscriptions,
    canceledsubscription,
  },
  getSubscribers,
  getSubscriptions,
  getActiveSubscriptions,
}) => {
  useEffect(() => {
    getProfileById(match.params.channelid);
    getUsers(match.params.channelid);
    getSubscriptions();
    getActiveSubscriptions(match.params.channelid);
    getSubscribers(match.params.channelid);
  }, [
    getProfileById,
    getUsers,
    getSubscriptions,
    getActiveSubscriptions,
    getSubscribers,
  ]);

  const [showModal, setShowModal] = useState(false);
  const [showUnfollowedUser, setShowUnfollowUser] = useState({
    request: false,
    confirm: false,
  });
  const [showBefriend, setShowBefriend] = useState({
    request: false,
    confirm: false,
  });
  const [showRemovedUser, setShowRemovedUser] = useState({
    request: false,
    confirm: false,
  });
  const [unfollowedUser, setUnfollowedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    location: {},
  });

  const [befriendedUser, setBefriendedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    location: {},
  });

  const [removedUser, setRemovedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    location: {},
  });

  const [view, setView] = useState({
    friends: true,
    subscriber: false,
    subscribers: false,
    following: false,
    followers: false,
    approvals: false,
  });

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {showBefriend.request && (
        <Befriend
          addFollowingFriend={addFollowingFriend}
          befriendedUser={befriendedUser}
          setShowBefriend={setShowBefriend}
        />
      )}
      {showBefriend.confirm && (
        <BefriendConfirm
          user={user}
          befriendedUser={befriendedUser}
          setShowBefriend={setShowBefriend}
        />
      )}
      {showUnfollowedUser.request && (
        <UnfollowUser
          user={user}
          unfollowedUser={unfollowedUser}
          setShowUnfollowUser={setShowUnfollowUser}
          unfollowUser={unfollowUser}
        />
      )}
      {showUnfollowedUser.confirm && (
        <UnfollowUserConfirm
          user={user}
          unfollowedUser={unfollowedUser}
          setShowUnfollowUser={setShowUnfollowUser}
        />
      )}
      {showRemovedUser.request && (
        <RemoveFriend
          match={match}
          user={removedUser}
          removeCasualFriend={removeCasualFriend}
          setShowRemovedUser={setShowRemovedUser}
          removeCasualFriendNotifications={removeCasualFriendNotifications}
        />
      )}
      {profile && profile.role === "innovator" && (
        <div>
          <LoggedInNav />
          <div className="flex-all-content-fixed-no-scroll">
            <section className="main-body-users">
              <div className="active-view">
                {user.role !== "employer" && (
                  <button
                    onClick={() =>
                      setView({
                        friends: true,
                        subscriber: false,
                        subscribers: false,
                        following: false,
                        followers: false,
                        approvals: false,
                      })
                    }
                    className="section-title green background-dark-black"
                  >
                    Friends
                    {view.friends && (
                      <i className="far fa-check-circle mx-5 green"></i>
                    )}
                  </button>
                )}
                {user && user.channelid === profile.channelid && (
                  <button
                    onClick={() =>
                      setView({
                        friends: false,
                        subscriber: true,
                        subscribers: false,
                        following: false,
                        followers: false,
                        approvals: false,
                      })
                    }
                    className="section-title green background-dark-black"
                  >
                    Subscriptions
                    {view.subscriber && (
                      <i className="far fa-check-circle mx-5 green"></i>
                    )}
                  </button>
                )}
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: true,
                      followers: false,
                      approvals: false,
                    })
                  }
                  className="section-title green background-dark-black"
                >
                  Following
                  {view.following && (
                    <i className="far fa-check-circle mx-5 green"></i>
                  )}
                </button>
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: false,
                      followers: true,
                      approvals: false,
                    })
                  }
                  className="section-title green background-dark-black"
                >
                  Followers
                  {view.followers && (
                    <i className="far fa-check-circle mx-5 green"></i>
                  )}
                </button>
              </div>
              <div className="user-search-container">
                <div className="article-search-container">
                  <form action="" className="trending-form-flex">
                    <div className="label-input">
                      <label htmlFor="" className="trending-labels green">
                        Search
                        <i className="fas fa-search green mx-5"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden">
                          <input
                            className="search-input-style"
                            type="text"
                            name="mentors"
                            placeholder="Enter User Name..."
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {loading ? (
                <div className="profile-error">
                  <img src={GreenSpinner} />
                </div>
              ) : (
                <div>
                  {view.friends && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-user-friends fa-2x mr-5 green"></i>
                        <p className="section-name">
                          Friends
                          <span className="mx-5 green">
                            {friends.mutual_friends &&
                              friends.mutual_friends.length <= 0 &&
                              friends.mutual_friends.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.mutual_friends &&
                          friends.mutual_friends.map((friend) => (
                            <UserFriendItem
                              profile={profile}
                              user={user}
                              key={friend._id}
                              friend={friend}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setRemovedUser={setRemovedUser}
                              setShowRemovedUser={setShowRemovedUser}
                            />
                          ))}
                        {friends.mutual_friends &&
                          friends.mutual_friends.length <= 0 && (
                            <p className="empty-content green">No Friends</p>
                          )}
                      </div>
                    </section>
                  )}
                  {view.subscriber &&
                    user.channelid === profile.channelid &&
                    subscriptions && (
                      <section className="friends-section">
                        <div className="user-section-name">
                          <i className="fas fa-star fa-2x mr-5 green"></i>
                          <p className="section-name">
                            Subscriptions
                            <span className="mx-5 green">
                              {subscriptions && subscriptions.length}
                            </span>
                          </p>
                        </div>
                        <div className="friend-results">
                          {subscriptions &&
                            subscriptions.map((subscription) => (
                              <UserSubscriptionItem
                                key={subscription._id}
                                subscription={subscription}
                                showModal={showModal}
                                setShowModal={setShowModal}
                              />
                            ))}
                          {subscriptions && subscriptions.length <= 0 && (
                            <p className="empty-content green">
                              No Subscriptions
                            </p>
                          )}
                        </div>
                      </section>
                    )}
                  {view.followers && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-users fa-2x mr-5 green"></i>
                        <p className="section-name">
                          Followers
                          <span className="mx-5 green">
                            {friends.followers &&
                              friends.followers.length <= 0 &&
                              friends.followers.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.followers &&
                          friends.followers.map((friend) => (
                            <UserFollowerItem
                              key={friend._id}
                              friend={friend}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setUnfollowedUser={setUnfollowedUser}
                              setShowUnfollowUser={setShowUnfollowUser}
                              setShowBefriend={setShowBefriend}
                              setBefriendedUser={setBefriendedUser}
                            />
                          ))}
                        {friends.followers && friends.followers.length <= 0 && (
                          <p className="empty-content green">No Followers</p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.following && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-check fa-2x mr-5 green"></i>
                        <p className="section-name">
                          Following
                          <span className="mx-5 green">
                            {friends.following &&
                              friends.following.length <= 0 &&
                              friends.following.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.following &&
                          friends.following.map((friend) => (
                            <UserFollowingItem
                              key={friend._id}
                              friend={friend}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setUnfollowedUser={setUnfollowedUser}
                              setShowUnfollowUser={setShowUnfollowUser}
                            />
                          ))}
                        {friends.following && friends.following.length <= 0 && (
                          <p className="empty-content green">
                            No Followed Users
                          </p>
                        )}
                      </div>
                    </section>
                  )}
                </div>
              )}
            </section>
          </div>
        </div>
      )}
      {profile && profile.role === "mentor" && (
        <div>
          <LoggedInNavRed />
          <div className="flex-all-content-fixed-no-scroll">
            <section className="main-body-users">
              <div className="active-view">
                <button
                  onClick={() =>
                    setView({
                      friends: true,
                      subscriber: false,
                      subscribers: false,
                      following: false,
                      followers: false,
                      approvals: false,
                    })
                  }
                  className="section-title red background-dark-black"
                >
                  Friends
                  {view.friends && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </button>
                {user.channelid === profile.channelid && (
                  <button
                    onClick={() =>
                      setView({
                        friends: false,
                        subscriber: false,
                        subscribers: true,
                        following: false,
                        followers: false,
                        approvals: false,
                      })
                    }
                    className="section-title red background-dark-black"
                  >
                    Subscribers
                    {view.subscribers && (
                      <i className="far fa-check-circle mx-5 red"></i>
                    )}
                  </button>
                )}
                {user.channelid === profile.channelid && (
                  <button
                    onClick={() =>
                      setView({
                        friends: false,
                        subscriber: true,
                        subscribers: false,
                        following: false,
                        followers: false,
                        approvals: false,
                      })
                    }
                    className="section-title red background-dark-black"
                  >
                    Subscriptions
                    {view.subscriber && (
                      <i className="far fa-check-circle mx-5 red"></i>
                    )}
                  </button>
                )}
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: true,
                      followers: false,
                      approvals: false,
                    })
                  }
                  className="section-title red background-dark-black"
                >
                  Following
                  {view.following && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </button>
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: false,
                      followers: true,
                      approvals: false,
                    })
                  }
                  className="section-title red background-dark-black"
                >
                  Followers
                  {view.followers && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </button>
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: false,
                      followers: false,
                      approvals: true,
                    })
                  }
                  className="section-title red background-dark-black"
                >
                  Approvals
                  {view.approvals && (
                    <i className="far fa-check-circle mx-5 red"></i>
                  )}
                </button>
              </div>
              <div className="user-search-container">
                <div className="article-search-container">
                  <form action="" className="trending-form-flex">
                    <div className="label-input">
                      <label htmlFor="" className="trending-labels red">
                        Search
                        <i className="fas fa-search red mx-5"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden">
                          <input
                            className="search-input-style"
                            type="text"
                            name="mentors"
                            placeholder="Enter User Name..."
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {loading ? (
                <div className="profile-error">
                  <img src={RedSpinner} />
                </div>
              ) : (
                <div>
                  {view.friends && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-user-friends fa-2x mr-5 red"></i>
                        <p className="section-name">
                          Friends
                          <span className="mx-5 red">
                            {friends.mutual_friends &&
                              friends.mutual_friends.length <= 0 &&
                              friends.mutual_friends.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.mutual_friends &&
                          friends.mutual_friends.map((friend) => (
                            <UserFriendItem
                              profile={profile}
                              user={user}
                              key={friend._id}
                              friend={friend}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setRemovedUser={setRemovedUser}
                              setShowRemovedUser={setShowRemovedUser}
                            />
                          ))}
                        {friends.mutual_friends &&
                          friends.mutual_friends.length <= 0 && (
                            <p className="empty-content red">No Friends</p>
                          )}
                      </div>
                    </section>
                  )}
                  {view.subscribers && user.channelid === profile.channelid && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-medal fa-2x mr-5 red"></i>
                        <p className="section-name">
                          Subscribers
                          <span className="mx-5 red">
                            {subscribers && subscribers.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {subscribers &&
                          subscribers.map((subscriber) => {
                            return (
                              <ActiveSubscriberItem
                                key={subscriber._id}
                                user={user}
                                subscriber={subscriber}
                                profile={profile}
                                showModal={showModal}
                                setShowModal={setShowModal}
                              />
                            );
                          })}
                        {subscribers && subscribers.length <= 0 && (
                          <p className="empty-content red">No Subscribers</p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.subscriber && user.channelid === profile.channelid && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-star fa-2x mr-5 red"></i>
                        <p className="section-name">
                          Subscriptions
                          <span className="mx-5 red">
                            {subscriptions && subscriptions.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {subscriptions &&
                          subscriptions.map((subscription) => (
                            <UserSubscriptionItem
                              key={subscription._id}
                              subscription={subscription}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                            />
                          ))}
                        {subscriptions && subscriptions.length <= 0 && (
                          <p className="empty-content red">No Subscriptions</p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.followers && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-users fa-2x mr-5 red"></i>
                        <p className="section-name">
                          Followers
                          <span className="mx-5 red">
                            {friends.followers &&
                              friends.followers.length >= 0 &&
                              friends.followers.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.followers.length > 0 &&
                          friends.followers.map((friend) => {
                            return (
                              <UserFollowerItem
                                key={friend._id}
                                friend={friend}
                                user={user}
                                profile={profile}
                                showModal={showModal}
                                setShowModal={setShowModal}
                                setUnfollowedUser={setUnfollowedUser}
                                setShowUnfollowUser={setShowUnfollowUser}
                                setShowBefriend={setShowBefriend}
                                setBefriendedUser={setBefriendedUser}
                              />
                            );
                          })}
                        {friends.followers && friends.followers.length <= 0 && (
                          <p className="empty-content red">No Followers</p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.following && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-check fa-2x mr-5 red"></i>
                        <p className="section-name">
                          Following
                          <span className="mx-5 red">
                            {friends.following &&
                              friends.following.length <= 0 &&
                              friends.following.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.following &&
                          friends.following.map((friend) => (
                            <UserFollowingItem
                              key={friend._id}
                              friend={friend}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setUnfollowedUser={setUnfollowedUser}
                              setShowUnfollowUser={setShowUnfollowUser}
                            />
                          ))}
                        {friends.following && friends.following.length <= 0 && (
                          <p className="empty-content red">No Followed Users</p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.approvals && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-file-signature fa-2x mr-5 red"></i>
                        <p className="section-name">
                          Approvals
                          <span className="mx-5 red">
                            {friends.approvals &&
                              friends.approvals.length <= 0 &&
                              friends.approvals.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.approvals &&
                          friends.approvals.map((employerapproval) => (
                            <ApprovalItem
                              key={employerapproval._id}
                              employerapproval={employerapproval}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                            />
                          ))}
                        {friends.approvals && friends.approvals.length <= 0 && (
                          <p className="empty-content red">No Approvals</p>
                        )}
                      </div>
                    </section>
                  )}
                </div>
              )}
            </section>
          </div>
        </div>
      )}
      {profile && profile.role === "employer" && (
        <div>
          <LoggedInNavBlue />
          <div className="flex-all-content-fixed-no-scroll">
            <section className="main-body-users">
              <div className="active-view">
                {user.role === "employer" && (
                  <button
                    onClick={() =>
                      setView({
                        friends: true,
                        subscriber: false,
                        subscribers: false,
                        following: false,
                        followers: false,
                        approvals: false,
                      })
                    }
                    className="section-title blue background-dark-black"
                  >
                    Friends
                    {view.friends && (
                      <i className="far fa-check-circle mx-5 blue"></i>
                    )}
                  </button>
                )}
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: true,
                      following: true,
                      followers: false,
                      approvals: false,
                    })
                  }
                  className="section-title blue background-dark-black"
                >
                  Following
                  {view.following && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </button>
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: false,
                      followers: true,
                      approvals: false,
                    })
                  }
                  className="section-title blue background-dark-black"
                >
                  Followers
                  {view.followers && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </button>
                <button
                  onClick={() =>
                    setView({
                      friends: false,
                      subscriber: false,
                      subscribers: false,
                      following: false,
                      followers: false,
                      approvals: true,
                    })
                  }
                  className="section-title blue background-dark-black"
                >
                  Approvals
                  {view.approvals && (
                    <i className="far fa-check-circle mx-5 blue"></i>
                  )}
                </button>
              </div>
              <div className="user-search-container">
                <div className="article-search-container">
                  <form action="" className="trending-form-flex">
                    <div className="label-input">
                      <label htmlFor="" className="trending-labels blue bold">
                        Search
                        <i className="fas fa-search blue mx-5"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden">
                          <input
                            className="search-input-style"
                            type="text"
                            name="mentors"
                            placeholder="Enter User Name..."
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {loading ? (
                <div className="profile-error">
                  <img src={BlueSpinner} />
                </div>
              ) : (
                <div>
                  {view.friends && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-user-friends fa-2x mr-5 blue"></i>
                        <p className="section-name">
                          Friends
                          <span className="mx-5 blue">
                            {friends.mutual_friends &&
                              friends.mutual_friends.length <= 0 &&
                              friends.mutual_friends.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.mutual_friends &&
                          friends.mutual_friends.map((friend) => (
                            <UserFriendItem
                              profile={profile}
                              user={user}
                              key={friend._id}
                              friend={friend}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setRemovedUser={setRemovedUser}
                              setShowRemovedUser={setShowRemovedUser}
                            />
                          ))}
                        {friends.mutual_friends &&
                          friends.mutual_friends.length <= 0 && (
                            <p className="empty-content blue">No Friends</p>
                          )}
                      </div>
                    </section>
                  )}
                  {view.followers && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-users fa-2x mr-5 blue"></i>
                        <p className="section-name">
                          Followers
                          <span className="mx-5 blue">
                            {friends.followers &&
                              friends.followers.length <= 0 &&
                              friends.followers.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.followers &&
                          friends.followers.map((friend) => (
                            <UserFollowerItem
                              key={friend._id}
                              friend={friend}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setUnfollowedUser={setUnfollowedUser}
                              setShowUnfollowUser={setShowUnfollowUser}
                              setShowBefriend={setShowBefriend}
                              setBefriendedUser={setBefriendedUser}
                            />
                          ))}
                        {friends.followers && friends.followers.length <= 0 && (
                          <p className="empty-content blue">No Followers</p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.following && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-check fa-2x mr-5 blue"></i>
                        <p className="section-name">
                          Following
                          <span className="mx-5 blue">
                            {friends.following &&
                              friends.following.length <= 0 &&
                              friends.following.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.following &&
                          friends.following.map((friend) => (
                            <UserFollowingItem
                              key={friend._id}
                              friend={friend}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              setUnfollowedUser={setUnfollowedUser}
                              setShowUnfollowUser={setShowUnfollowUser}
                            />
                          ))}
                        {friends.following && friends.following.length <= 0 && (
                          <p className="empty-content blue">
                            No Followed Users
                          </p>
                        )}
                      </div>
                    </section>
                  )}
                  {view.approvals && (
                    <section className="friends-section">
                      <div className="user-section-name">
                        <i className="fas fa-file-signature fa-2x mr-5 blue"></i>
                        <p className="section-name">
                          Approvals
                          <span className="mx-5 blue bold">
                            {friends.approved_mentors &&
                              friends.approved_mentors.length <= 0 &&
                              friends.approved_mentors.length}
                          </span>
                        </p>
                      </div>
                      <div className="friend-results">
                        {friends.approved_mentors &&
                          friends.approved_mentors.map((approvedmentor) => (
                            <ApprovedMentorItem
                              key={approvedmentor._id}
                              approvedmentor={approvedmentor}
                              user={user}
                              profile={profile}
                              showModal={showModal}
                              setShowModal={setShowModal}
                            />
                          ))}
                        {friends.approved_mentors &&
                          friends.approved_mentors.length <= 0 && (
                            <p className="empty-content blue">
                              No Approved Mentors
                            </p>
                          )}
                      </div>
                    </section>
                  )}
                </div>
              )}
            </section>
          </div>
        </div>
      )}
    </Fragment>
  );
};

Users.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  unfollowUser: PropTypes.func.isRequired,
  addFollowingFriend: PropTypes.func.isRequired,
  removeCasualFriend: PropTypes.func.isRequired,
  removeCasualFriendNotifications: PropTypes.func.isRequired,
  getSubscribers: PropTypes.func.isRequired,
  getActiveSubscriptions: PropTypes.func.isRequired,
  getSubscriptions: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  friend: PropTypes.object.isRequired,
  subscribe: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  friend: state.friend,
  subscribe: state.subscribe,
});

export default connect(mapStateToProps, {
  getProfileById,
  getUsers,
  getSubscribers,
  getSubscriptions,
  getActiveSubscriptions,
  unfollowUser,
  addFollowingFriend,
  removeCasualFriend,
  removeCasualFriendNotifications,
})(Users);
